import React from "react";
import { Link } from "react-router-dom";
import { FaTelegramPlane, FaFacebookF, FaTwitter } from "react-icons/fa";
import { BiLogoInstagramAlt } from "react-icons/bi";
import cards from "../assets/cards.png";
import Success from "../Components/Modal.Success";
export default function Footer() {
  const [email , setEmail] = React.useState("");

  function handlechange() {
    if (email) {
      Success("You have successfully subscribed to our newsletter.");
      setEmail("");
    } else {
      Success("Please enter a valid email address.");
    }
  }
  return (
    <>
      <div>
        
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-lg-11">
              <section className="footer">
            <div className="row">
              <div className="col-lg-6">
              <h3>Subscribe Newsletters</h3>
                   
              </div>
              <div className="col-lg-6">
              <div class="fotr-input-2">
                      {/* <input
                        type="text"
                        class="form-control"
                        placeholder="Email Address here..."
                        aria-describedby=""
                      /> */}

                              <input type="text" className="form-control" placeholder="Email Address here..." value={email}  onChange={(e) =>  setEmail(e.target.value)} />

                      <div className="btn btn1 " onClick={handlechange}>
                      Subcribe Now
                      </div>
                    </div>
              </div>
             
            </div>
            </section>
              </div>
            </div>
         
          </div>
        
        
          <div className="container-fluid">
            <div className="row  justify-content-center">
              <div className="col-11">
              <section className="footerBottom">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <ul className="pl-0 m-0 d-flex" >
                      <li>
                        <Link to="/">
                        Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/products">
                        Shop
                        </Link>
                      </li>
                      <li>
                        <Link to="/about">
                        About Us
                        </Link>
                      </li>

                      <li>
                        <Link to="/contact-us">
                        Contact
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12  d-flex justify-content-end">
                    <div className="socialBtn ">
                      <FaFacebookF />
                    </div>
                    &emsp;
                    <div className="socialBtn ">
                      <FaTwitter />
                    </div>
                    &emsp;
                    <div className="socialBtn ">
                      <BiLogoInstagramAlt />
                    </div>
                  </div>
                </div>
                </section>
              </div>
            </div>
          </div>
        
        <section className="footerBar">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-lg-11">
                <div className="row pt-3 justify-space-between align-items-center footerRow">
                  <div className="col">
                    <p className>
                      Copyright {new Date().getFullYear()} © PREDIVAUTH. All
                      rights reserved.
                    </p>
                  </div>
                  <div className="col text-center">
                    <img src="./images/footer-logo.png" height="70px" />
                  </div>
                  <div className="col text-right footerCards">
                    <ul className="pl-0 footerList m-0 d-flex justify-content-end">
                      <li>
                        <Link to="/products">Terms & Conditions</Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                      </li>
                    </ul>

                    {/* <img src={cards} height="30px"/> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
